// extracted by extract-css-chunks-webpack-plugin
module.exports = {"video_box":"video_box-3yo2xckM","video":"video-68B1YBUN"};